module.exports = __webpack_public_path__ + "static/media/startBanner.86c2696d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/startBanner.jpg
// module id = 662
// module chunks = 0